<template>
  <section :class="['flex flex-col gap-9 lg:gap-15 transition-[gap]', backgroundClasses]">
    <CTABlock
      :button="content.buttons?.length ? content.buttons[0] : null"
      :description="content.description"
      :title="content.title"
    />
    <ul
      class="flex flex-col lg:flex-row justify-center items-center gap-4 lg:gap-6 transition-[margin_gap] max-w-300 mx-auto"
    >
      <ContentCard
        :border="content.background === 'dustrose'"
        :content="card"
        v-for="(card, cardIndex) in content.items"
        :key="card.flexKey"
        v-reveal="{ delay: 200 + cardIndex * 50 }"
      />
    </ul>
  </section>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import CTABlock from '@/components/blocks/CTABlock.vue'
import ContentCard from '@/components/cards/ContentCard.vue'
import { useBackgroundColor } from '@/composables/useBackgroundColor.ts'

export default {
  name: 'CardsSection',
  components: { ContentCard, CTABlock },
  props: {
    content: {
      type: Object as PropType<CardsSection>,
      required: true,
    },
  },
  setup(props) {
    return {
      backgroundClasses: useBackgroundColor(toRef(props.content, 'background')),
    }
  },
}
</script>
